import React from 'react'
import Baner from '../Baner/Baner'
import "./landingPage.scss"
function LandingPage() {
  return (
    <>
        <Baner/>
    </>
  )
}

export default LandingPage